export default __webpack_public_path__ + "static/media/emptyCheckBox.40bec077.svg";